module.exports = __webpack_public_path__ + "static/img/logo10.fd737059.jpg";